import { definePreset } from "@primeng/themes";
import Aura from "@primeng/themes/aura";

const concretePreset = definePreset(Aura, {
  primitive: {},
  semantic: {
    colorScheme: {
      light: {},
      dark: {},
    },
  },
  components: {
    tag: {
      colorScheme: {
        light: {
          fontSize: "12px",
        },
      },
    },
    breadcrumb: {
      colorScheme: {
        light: {
          background: "transparent",
        },
      },
    },
    button: {
      colorScheme: {
        light: {
          background: "transparent",
        },
      },
    },
    dynamicdialog: {
      colorScheme: {
        light: {
          padding: "0px",
        },
      },
    },
  },
});

export default concretePreset;
